import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Skeleton } from 'antd';
import { BlockNames } from './block.types';

const registerLazyBlock = (
	piletApi: PiletApi,
	blockName: string,
	importFunc: () => Promise<{ default: React.ComponentType<any> }>
) => {
	const LazyComponent = React.lazy(importFunc);
	piletApi.registerExtension(blockName, props => (
		<React.Suspense fallback={<Skeleton />}>
			<LazyComponent {...props} />
		</React.Suspense>
	));
};

export const addBlocks = (piletApi: PiletApi) => {
	registerLazyBlock(piletApi, BlockNames.DataSource, () => import('./DataSource'));
	registerLazyBlock(piletApi, BlockNames.TaskDetail, () => import('./TaskDetails'));
};
